import { getWsBaseURL } from '@src/RelayEnvironment';
import { Socket } from 'phoenix'

let socket: Socket;

/**
 * Get or create a chat socket
 */
export function getChatSocket(): Socket {
  if (!socket) {
    const token = localStorage.getItem('token');
    socket = new Socket(getWsBaseURL() + '/chat', { params: { token } });
    socket.connect();
  }
  return socket;
}